import backofficeService from '../../../api/backoffice'
let cachecollection = null
export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  async getAll(params) {
    if (cachecollection) return cachecollection
    return backofficeService.Api().get('collection', {
        params
      })
      .then(response => {
        cachecollection = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`collection/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('collection', data)
      .then(response => {
        cachecollection = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`collection/${id}`, data)
      .then(response => {
        cachecollection = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`collection/${id}`, {
        params
      })
      .then(response => {
        cachecollection = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  merge(data) {
    return backofficeService.Api().post('collection/merge', data)
      .then(response => {
        cachecollection = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

}